// import React from "react";
// import {
//   Card,
//   CardContent,
//   CardMedia,
//   Typography,
//   Button,
//   CardActions,
// } from "@mui/material";
// import { Link } from "react-router-dom"; // Import Link

// // Add 'id' to the props
// const CaseStudyCard = ({ id, clientName, shortDescription, imageUrl }) => {
//   return (
//     <Card
//       sx={{ height: "100%", display: "flex", flexDirection: "column" }}
//       onClick={() => {
//         window.location.href = `/case-studies/${id}`;
//       }}
//     >
//       <CardMedia
//         component="img"
//         height="200"
//         image={imageUrl}
//         alt={`${clientName} case study`}
//       />
//       <CardContent sx={{ flexGrow: 1 }}>
//         <Typography gutterBottom variant="h5" component="div">
//           {clientName}
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           {shortDescription}
//         </Typography>
//       </CardContent>
//       <CardActions>
//         {/* Update Button to use the Link component */}
//         <Button component={Link} to={`/case-studies/${id}`} size="small">
//           Read More
//         </Button>
//       </CardActions>
//     </Card>
//   );
// };

// export default CaseStudyCard;

// v2
import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  CardActions,
} from "@mui/material";
import { Link } from "react-router-dom"; // Import Link

// Add 'id' to the props
const CaseStudyCard = ({ id, clientName, shortDescription, imageUrl }) => {
  return (
    <Card
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      onClick={() => {
        window.location.href = `/case-studies/${id}`;
      }}
    >
      <CardMedia
        component="img"
        sx={{
          width: "100%",
          height: "240px",
          objectFit: "cover",
          objectPosition: "center 30%",
        }}
        image={imageUrl}
        alt={`${clientName} case study`}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant="h5" component="div">
          {clientName}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {shortDescription}
        </Typography>
      </CardContent>
      <CardActions>
        {/* Update Button to use the Link component */}
        <Button component={Link} to={`/case-studies/${id}`} size="small">
          Read More
        </Button>
      </CardActions>
    </Card>
  );
};

export default CaseStudyCard;
